export default "__VITE_ASSET__DUVU$iO1__"